import {useState, useEffect} from 'react';
import { observer } from 'mobx-react';
import './style.scss';

const View = observer(({children, className, style={}}) => {
    const [InnerWidth, setInnerWidth] = useState(`${window.innerWidth}px`);
    const [InnerHeight, setInnerHeight] = useState(`${window.innerHeight}px`);

    useEffect(() => {
        const handleResize = () => {
        setInnerWidth(`${window.innerWidth}px`)
        setInnerHeight(`${window.innerHeight}px`)
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!style.minWidth) style.minWidth = InnerWidth;
    if (!style.width) style.width = InnerWidth;
    if (!style.height) style.height = InnerHeight;
    if (!style.minHeight) style.minHeight = InnerHeight;

    return (
        <div className={`view ${className}`} id='viewContainer' style = {style}>
            {children}
        </div>
    )
})

export default View;